export const GET_PRODUCT_RECOMMENDATIONS = 'GET_PRODUCT_RECOMMENDATIONS';
export const GET_PRODUCT_RECOMMENDATIONS_SUCCESS =
  'GET_PRODUCT_RECOMMENDATIONS_SUCCESS';
export const GET_PRODUCT_RECOMMENDATIONS_FAIL =
  'GET_PRODUCT_RECOMMENDATIONS_FAIL';

export function getProductRecommendations(payload) {
  return {
    types: [
      GET_PRODUCT_RECOMMENDATIONS,
      GET_PRODUCT_RECOMMENDATIONS_SUCCESS,
      GET_PRODUCT_RECOMMENDATIONS_FAIL,
    ],
    promise: (client) =>
      client.post('/api/getProductRecommendations', {
        data: payload,
      }),
  };
}
